import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { LogoutRequestBody, LogoutResponse } from "./types";

export class LogoutAPI extends BaseAPI<
    LogoutRequestBody,
    LogoutResponse
> {
    protected route = ApiRoutes.auth.logout;
    protected method = RequestMethod.POST;
}
